<!-- eslint-disable max-len -->
<style scoped>
  .map-alert {
    position: absolute;
    bottom: 0px;
    left: 20px;
    z-index: 9999
  }
  .portal-item-list {
    padding: 10px;
  }
  .portal-item-label {
    padding-left: 6px;
  }
  .site-map-overlay {
    height: 100%;
  }
  #site-map {
    height:100%;
  }
  #site-map .card {
    height:calc(100% - 31px);
  }
  #site-map .card-body {
    height:100%;
    padding: 0;
  }
  #esriMap {
    padding: 0;
    margin: 0;
    width: 100%;
    min-height: 480px;
    height: 100%;
  }
</style>
<template>
  <div id="site-map">
    <div class="section-title">Site Map</div>
    <div v-if="currentSite" class="card">
      <b-overlay class='site-map-overlay' :show="isSaving">
      <div class="card-body">
        <div id="esriMap">
          <b-alert :show="dismissGeocodeSuccess" dismissible variant="success" @dismissed="dismissGeocodeSuccess=0" @dismiss-count-down="showGeocodeSuccessChanged" class='map-alert'>Site was successfully geocoded</b-alert>
          <b-alert :show="dismissGeocodeWarning" dismissible variant="warning" @dismissed="dismissGeocodeWarning=0" @dismiss-count-down="showGeocodeWarningChanged" class='map-alert'>Site could not be geocoded</b-alert>
          <b-alert :show="dismissEditInstructions" dismissible variant="info" class='map-alert'>Click tax lots to add to site boundary<br/>Click again to remove</b-alert>
          <b-alert
            :show="dismissGetSiteTaxlotsWarning"
            class='map-alert'
            dismissible variant="warning"
            @dismissed="dismissGetSiteTaxlotsWarning=0"
            @dismiss-count-down="showGetSiteTaxlotsWarningChanged"
          >
            <div>The Site Taxlots could not be fetched from Insightly within the configured limits.</div>
            <div>Please refresh this page.</div>
          </b-alert>
          <b-alert
            :show="dismissGetSiteWarning"
            class='map-alert'
            dismissible variant="warning"
            @dismissed="dismissGetSiteWarning=0"
            @dismiss-count-down="showGetSiteWarningChanged"
          >
            <div>This Site has related Insightly Tax Lots, but no longer has a corresponding ArcGIS feature!</div>
            <div>Please contact your GIS administrator.</div>
          </b-alert>
        </div>
        <div style="display:none;">
          <div ref="btnEdit" v-show="btnEditShow" @click="btnEditOnClick" class="btn site-action-button btn-primary btn-sm rounded-pill">Edit</div>
          <div ref="btnCancel" v-show="!btnEditShow" @click="btnCancelOnClick" class="btn site-action-button btn-primary btn-sm rounded-pill">Cancel</div>
          <div ref="btnSave" v-show="!btnEditShow" @click="btnSaveOnClick" class="btn site-action-button btn-primary btn-sm rounded-pill">Save</div>
          <div ref="btnClear" v-show="!btnEditShow" @click="btnClearOnClick" class="btn site-action-button btn-primary btn-sm rounded-pill">Clear</div>
          <div ref="portalItemList" class="esri-widget esri-widget--panel portal-item-list"/>
          <input ref="portalItemRadioButton" type="radio" name="webmap"/>
          <label ref="portalItemLabel" class="portal-item-label"/>
        </div>
      </div>
      </b-overlay>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len, no-await-in-loop, no-loop-func, no-plusplus, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';
import { Store, get, set } from 'idb-keyval';
import { loadModules } from 'esri-loader';

export default {
  name: 'Map',
  computed: {
    ...mapState(['config', 'currentSite']),
    ...mapState('SiteTaxlots', {
      siteTaxlots: (state) => state.siteTaxlots,
    }),
  },
  data() {
    return {
      dismissGeocodeSuccess: 0,
      dismissGeocodeWarning: 0,
      dismissGetSiteTaxlotsWarning: 0,
      dismissGetSiteWarning: 0,
      dismissEditInstructions: false,
      btnEditShow: true,
      isSaving: false,
    };
  },
  watch: {
    /* eslint-disable-next-line */
    currentSite: function (currentSite) {
      this.selectedTaxlots = [];
      this.$store.dispatch('SiteTaxlots/readSiteTaxlots', this.currentSite.Id).then(() => {
        this.loadMap();
      });
    },
  },
  mounted() {
    this.selectedTaxlots = [];
    this.$store.dispatch('SiteTaxlots/readSiteTaxlots', this.currentSite.Id).then(() => {
      this.loadMap();
    });
  },
  beforeDestroy() {
    if (this.view) {
      this.view.container = null;
    }
  },
  methods: {
    async addBasemaps(basemapsConfig) {

      await loadModules(['esri/Basemap', 'esri/layers/TileLayer', 'esri/Map', 'esri/WebMap']).then(async ([Basemap, TileLayer, Map, WebMap]) => {

        this.maps = [];

        basemapsConfig.forEach((item) => {

          if (item.class === 'TileLayerBaseMap') {

            const tileLayer = new TileLayer(item.object);

            const basemap = new Basemap({
              baseLayers: [tileLayer],
            });

            this.maps.push(new Map({
              title: item.object.title,
              basemap,
            }));

          }

          if (item.class === 'Map') {
            this.maps.push(new Map(item.object));
          }

          if (item.class === 'WebMap') {
            const webMap = new WebMap(item.object);
            webMap.allLayers.on('change', () => {
              const targetLayer = webMap.allLayers.items.find((layer) => layer.id === 'World_Transportation_5177');
              if (targetLayer) {
                targetLayer.visible = true;
              }
            });
            this.maps.push(webMap);
          }

        });
      });

    },
    addButtons() {
      [this.$refs.btnEdit, this.$refs.btnCancel, this.$refs.btnSave, this.$refs.btnClear].forEach((button) => this.view.ui.add(button, 'bottom-right'));
    },
    async addLayers(layersConfig) {

      await loadModules(['esri/layers/FeatureLayer', 'esri/layers/GraphicsLayer']).then(async ([FeatureLayer, GraphicsLayer]) => {

        this.layers = [];

        layersConfig.forEach(
          (referenceLayer) => this.layers.push(new FeatureLayer(referenceLayer)),
        );

        this.huc10Layer = this.layers.filter((layer) => layer.id === 'huc10FeatureLayer')[0];
        this.huc12Layer = this.layers.filter((layer) => layer.id === 'huc12FeatureLayer')[0];
        this.taxlotLayer = this.layers.filter((layer) => layer.id === 'taxlotFeatureLayer')[0];
        this.siteLayer = this.layers.filter((layer) => layer.id === 'siteFeatureLayer')[0];

        this.graphicsLayer = new GraphicsLayer();
        this.graphicsLayer.title = 'My Site';
        this.layers.push(this.graphicsLayer);

        this.layers.forEach((layer) => this.view.map.add(layer));

      });

    },
    async addLayerList() {

      await loadModules(['esri/widgets/Expand', 'esri/widgets/LayerList']).then(async ([Expand, LayerList]) => {

        this.layerList = new LayerList({
          container: document.createElement('div'),
          view: this.view,
        });

        this.layerListExpand = new Expand({
          expandIconClass: 'esri-icon-layer-list',
          expandTooltip: 'Expand Layers',
          group: 'legend-buttons',
          view: this.view,
          content: this.layerList,
        });

        this.view.ui.add(this.layerListExpand, { position: 'top-right' });
      });

    },
    addLegend() {

      // https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html
      // https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Expand.html
      // https://developers.arcgis.com/javascript/latest/guide/esri-icon-font/

      loadModules(['esri/widgets/Expand', 'esri/widgets/Legend']).then(([Expand, Legend]) => {

        this.legendExpand = new Expand({
          content: new Legend({
            view: this.view,
          }),
          expandIconClass: 'esri-icon-maps',
          expandTooltip: 'Expand Legend',
          group: 'legend-buttons',
          view: this.view,
        });

        this.view.ui.add(this.legendExpand, 'top-right');

      });
    },
    async addMapPicker() {

      // https://developers.arcgis.com/javascript/latest/sample-code/webmap-swap/index.html
      // https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Expand.html
      // https://developers.arcgis.com/javascript/latest/guide/esri-icon-font/

      await loadModules(['esri/widgets/Expand']).then(async ([Expand]) => {

        this.webmapList = this.$refs.portalItemList;

        this.maps.forEach((item, index) => {

          const radioButton = this.$refs.portalItemRadioButton.cloneNode();
          radioButton.setAttribute('value', index);
          radioButton.addEventListener('click', this.radioButtonOnClick);

          if (index === 0) {
            radioButton.setAttribute('checked', '');
          }

          const label = this.$refs.portalItemLabel.cloneNode();
          label.innerText = item.title;

          this.webmapList.appendChild(radioButton);
          this.webmapList.appendChild(label);

          if (index < (this.maps.length - 1)) {
            this.webmapList.appendChild(document.createElement('br'));
          }

        });

        this.webmapListExpand = new Expand({
          expandIconClass: 'esri-icon-basemap',
          expandTooltip: 'Expand Basemaps',
          group: 'legend-buttons',
          view: this.view,
          content: this.webmapList,
        });

        this.view.ui.add(this.webmapListExpand, { position: 'top-right' });

      });
    },
    btnCancelOnClick() {

      this.viewOnClickHandle.remove();
      this.hideEditInstructions();
      this.btnEditShow = true;
      this.unhighlightTaxlots();

      return false;
    },
    btnClearOnClick() {

      this.unhighlightTaxlots();
      this.selectedTaxlots = [];

      return false;
    },
    btnEditOnClick() {

      this.isSaving = true;

      this.$store.dispatch('SiteTaxlots/readSiteTaxlots', this.currentSite.Id).then(() => {

        this.isSaving = false;

        // Begin the edit session with an empty selected tax lots list
        this.selectedTaxlots = [];

        this.btnEditShow = false;
        this.viewOnClickHandle = this.view.on('click', this.viewOnClick);
        this.highlightSiteTaxlots();
        this.showEditInstructions();

      });
    },
    async btnSaveOnClick() {

      this.viewOnClickHandle.remove();
      this.hideEditInstructions();
      this.isSaving = true;

      loadModules([
        'esri/geometry/projection',
      ]).then(async ([projection]) => {
        projection.load().then(async () => {
          await this.saveSiteGeometry(this.currentSite, this.selectedTaxlots);
          await this.saveSiteAttributes(this.currentSite, this.selectedTaxlots, projection);
          this.isSaving = false;
        });
      });

      return false;
    },
    async getSiteAcreage(taxlots) {
      return loadModules([
        'esri/geometry/geometryEngine',
      ]).then(async ([geometryEngine]) => {
        let siteAcreage = 0;
        if (taxlots.length > 0) {
          taxlots.forEach((taxlot) => {
            let taxlotAcreage = 0;
            if (taxlot.graphic.attributes.a_t_acres) {
              taxlotAcreage = taxlot.graphic.attributes.a_t_acres;
            } else {
              taxlotAcreage = geometryEngine.geodesicArea(taxlot.graphic.geometry, 'acres');
            }
            siteAcreage += taxlotAcreage;
          });
        }
        return siteAcreage;
      });
    },
    async getSiteWatersheds(taxlots, featureLayer, projection) {
      return loadModules([
        'esri/geometry/geometryEngine',
        'esri/geometry/SpatialReference',
      ]).then(async ([geometryEngine, SpatialReference]) => {

        let siteGeometry = geometryEngine.union(
          taxlots.map((taxlot) => taxlot.graphic.geometry),
        );

        if (!siteGeometry.spatialReference.isWGS84) {
          siteGeometry = projection.project(
            siteGeometry,
            SpatialReference.WGS84,
          );
        }

        const query = featureLayer.createQuery();

        query.geometry = siteGeometry;
        query.spatialRelationship = 'intersects';
        query.returnGeometry = true;
        query.outFields = ['*'];

        const result = await featureLayer.queryFeatures(query);

        const huc12Watersheds = [];

        result.features.forEach((watershed) => {
          const area = geometryEngine.geodesicArea(geometryEngine.intersect(siteGeometry, watershed.geometry), 'square-meters');
          huc12Watersheds.push({
            watershedId: watershed.attributes.huc10,
            watershedName: watershed.attributes.huc10_name,
            subwatershedId: watershed.attributes.huc12,
            subwatershedName: watershed.attributes.huc12_name,
            area,
          });
        });

        huc12Watersheds.sort((a, b) => {
          if (a.area < b.area) {
            return -1;
          }
          if (a.area > b.area) {
            return 1;
          }
          return 0;
        });

        const item = huc12Watersheds[huc12Watersheds.length - 1];
        return item;
      });
    },
    getSiteTaxlotsDifference(taxlotIdsExpected) {
      const taxlotIdsActual = this.siteTaxlots.map((siteTaxlot) => siteTaxlot.taxlotGlobalId).sort();
      const taxlotsDifference = taxlotIdsExpected.filter(
        (x) => !taxlotIdsActual.includes(x),
      ).concat(
        taxlotIdsActual.filter(
          (x) => !taxlotIdsExpected.includes(x),
        ),
      );
      return taxlotsDifference;
    },
    highlightSiteTaxlots() {
      if (this.siteTaxlots && this.siteTaxlots.length > 0) {
        this.view.whenLayerView(this.taxlotLayer).then((layerView) => {
          const globalIds = this.siteTaxlots.map((siteTaxlot) => `'${siteTaxlot.taxlotGlobalId}'`).join(', ');
          const query = this.taxlotLayer.createQuery();
          query.where = `globalid IN (${globalIds})`;
          this.taxlotLayer.queryFeatures(query).then(async (results) => {
            results.features.forEach((feature) => {
              this.selectedTaxlots.push({
                graphic: feature,
                highlight: layerView.highlight(feature),
              });
            });
          });
        });
      }
    },
    unhighlightTaxlots() {
      this.selectedTaxlots.forEach((taxlot) => taxlot.highlight.remove());
    },
    async loadMap() {
      loadModules(
        ['esri/identity/IdentityManager', 'esri/views/MapView'],
        { css: true },
      ).then(async ([IdentityManager, MapView]) => {

        this.identityManager = IdentityManager;

        if (localStorage['acorn.identityManager']) {
          try {
            this.identityManager.initialize(localStorage['acorn.identityManager']);
          } catch (exception) {
            console.error('this.identityManager could not be initialized with localStorage[\'acorn.identityManager\']]');
          }
        }

        this.identityManager.on('credential-create', () => {
          try {
            localStorage['acorn.identityManager'] = JSON.stringify(this.identityManager.toJSON());
          } catch (exception) {
            console.error('localStorage[\'acorn.identityManager\'] could not be set with JSON.stringify(this.identityManager.toJSON())');
          }
        });

        await this.addBasemaps(this.config.siteMap.basemaps);

        this.view = new MapView({
          container: 'esriMap',
          map: this.maps[0],
          center: this.config.siteMap.defaultExtent.center,
          zoom: this.config.siteMap.defaultExtent.zoom,
        });

        this.view.ui.move('zoom', 'top-right');

        await this.addLayers(this.config.siteMap.layers);
        await this.addLayerList();
        await this.addMapPicker();
        this.addLegend();
        this.addButtons();

        if (this.siteTaxlots && this.siteTaxlots.length > 0) {
          this.setViewExtentBySiteGeometry();
        } else {
          this.setViewExtentBySiteAddress();
        }

      });
    },
    radioButtonOnClick(event) {
      this.view.map = this.maps[event.target.value];
      this.layers.forEach((layer) => this.view.map.add(layer));
      this.webmapListExpand.toggle();
    },
    setViewExtentBySiteAddress() {

      this.graphicsLayer.removeAll();

      loadModules(['esri/Graphic', 'esri/tasks/Locator', 'esri/widgets/Home']).then(([Graphic, Locator, Home]) => {

        this.view.whenLayerView(this.taxlotLayer).then(() => {

          this.locator = new Locator({
            outSpatialReference: { wkid: 102100 },
            url: this.config.siteMap.locator.url,
          });
          this.locator.addressToLocations({
            address: {
              SingleLine: `${this.currentSite.Site_Address__c} ${this.currentSite.City__c} OR`,
            },
            countryCode: 'US',
            forStorage: false,
          }).then((addressCandidates) => {

            const candidates = addressCandidates || [];

            if (
              candidates.length > 0 && candidates[0].score >= this.config.siteMap.locator.tolerance
            ) {

              const candidate = candidates[0];

              this.view.extent = candidate.extent;

              const graphic = new Graphic({
                geometry: candidate.location,
                symbol: this.config.siteMap.locator.markerSymbol,
              });

              this.graphicsLayer.add(graphic);

              const textGraphicSymbol = this.config.siteMap.locator.markerLabel;
              textGraphicSymbol.text = candidate.address;

              const textGraphic = new Graphic({
                geometry: candidate.location,
                symbol: textGraphicSymbol,
              });

              this.graphicsLayer.add(textGraphic);

              this.showGeocodeSuccess();

            } else {
              this.view.center = this.config.siteMap.defaultExtent.center;
              this.view.zoom = this.config.siteMap.defaultExtent.zoom;
              this.showGeocodeWarning();
            }

            if (this.homeButton) {
              this.view.ui.remove(this.homeButton);
            }

            this.homeButton = new Home({
              view: this.view,
            });

            this.view.ui.add({
              component: this.homeButton,
              position: 'top-right',
              index: 1,
            });

          });
        });
      });
    },
    setViewExtentBySiteGeometry() {
      loadModules([
        'esri/geometry/geometryEngine',
        'esri/geometry/projection',
        'esri/geometry/SpatialReference',
        'esri/Graphic',
        'esri/widgets/Home',
      ]).then(([
        geometryEngine,
        projection,
        SpatialReference,
        Graphic,
        Home,
      ]) => {
        this.view.whenLayerView(this.taxlotLayer).then(() => {

          projection.load().then(() => {

            const query = this.siteLayer.createQuery();
            query.where = `insightlyid = ${this.currentSite.Id}`;
            console.debug('query.where: ', query.where);

            this.siteLayer.queryFeatures(query).then((results) => {

              if (!results || !results.features || results.features.length === 0) {
                this.setViewExtentBySiteAddress();
                return;
              }

              this.graphicsLayer.removeAll();

              let siteGeometry = geometryEngine.union(
                results.features.map((feature) => feature.geometry),
              );

              if (!siteGeometry.spatialReference.isWGS84) {
                siteGeometry = projection.project(
                  siteGeometry,
                  SpatialReference.WGS84,
                );
              }

              const bufferGeometry = geometryEngine.geodesicBuffer(siteGeometry, 100, 'meters');

              const graphic = new Graphic({
                geometry: siteGeometry,
                symbol: this.config.siteMap.siteGeometry.symbol,
              });

              this.graphicsLayer.add(graphic);

              const textGraphicSymbol = this.config.siteMap.siteGeometry.label;
              textGraphicSymbol.text = this.currentSite.Site_Address__c;

              const textGraphic = new Graphic({
                geometry: siteGeometry.centroid,
                symbol: textGraphicSymbol,
              });

              this.graphicsLayer.add(textGraphic);

              this.view.extent = bufferGeometry.extent;

              if (this.homeButton) {
                this.view.ui.remove(this.homeButton);
              }

              this.homeButton = new Home({
                view: this.view,
              });

              this.view.ui.add({
                component: this.homeButton,
                position: 'top-right',
                index: 1,
              });

            });
          });
        });
      });
    },
    showEditInstructions() {
      this.dismissEditInstructions = true;
    },
    hideEditInstructions() {
      this.dismissEditInstructions = false;
    },
    showGeocodeSuccess() {
      this.dismissGeocodeSuccess = 5;
    },
    showGeocodeSuccessChanged(dismissGeocodeSuccess) {
      this.dismissGeocodeSuccess = dismissGeocodeSuccess;
    },
    showGeocodeWarning() {
      this.dismissGeocodeWarning = 5;
    },
    showGeocodeWarningChanged(dismissGeocodeWarning) {
      this.dismissGeocodeWarning = dismissGeocodeWarning;
    },
    showGetSiteTaxlotsWarning() {
      this.dismissGetSiteTaxlotsWarning = 5;
    },
    showGetSiteTaxlotsWarningChanged(dismissGetSiteTaxlotsWarning) {
      this.dismissGetSiteTaxlotsWarning = dismissGetSiteTaxlotsWarning;
    },
    showGetSiteWarning() {
      this.dismissGetSiteWarning = 5;
    },
    showGetSiteWarningChanged(dismissGetSiteWarning) {
      this.dismissGetSiteWarning = dismissGetSiteWarning;
    },
    viewOnClick(event) {
      this.view.hitTest(event).then((response) => {
        const hits = response.results.filter(
          (feature) => feature.graphic.layer.id === this.taxlotLayer.id,
        );
        this.view.whenLayerView(this.taxlotLayer).then((layerView) => {
          hits.forEach((hit) => {
            const filteredTaxlots = this.selectedTaxlots.filter(
              (taxlot) => taxlot.graphic.attributes.objectid === hit.graphic.attributes.objectid,
            );
            if (filteredTaxlots.length > 0) {
              filteredTaxlots.forEach((filteredTaxlot) => {
                filteredTaxlot.highlight.remove();
              });
              this.selectedTaxlots = this.selectedTaxlots.filter(
                (taxlot) => taxlot.graphic.attributes.objectid !== hit.graphic.attributes.objectid,
              );
            } else {
              // Get the actual graphic here
              const query = this.taxlotLayer.createQuery();
              query.objectIds = [hit.graphic.attributes.objectid];
              this.taxlotLayer.queryFeatures(query).then((results) => {
                this.selectedTaxlots.push({
                  graphic: results.features[0],
                  highlight: layerView.highlight(hit.graphic),
                });
              });
            }
          });
        });
      });
    },
    async saveSiteAttributes(site, taxlots, projection) {

      let siteAcreage = 0;

      let watersheds = {
        watershedId: '',
        watershedName: '',
        subwatershedId: '',
        subwatershedName: '',
      };

      if (taxlots.length > 0) {
        siteAcreage = await this.getSiteAcreage(taxlots);
        watersheds = await this.getSiteWatersheds(taxlots, this.huc12Layer, projection);
      }

      // update the Insightly entity
      await this.$store.dispatch(
        'SiteTaxlots/writeSiteAttributes',
        {
          id: this.currentSite.Id,
          acreage: siteAcreage,
          watershedId: watersheds.watershedId,
          watershedName: watersheds.watershedName,
          subwatershedId: watersheds.subwatershedId,
          subwatershedName: watersheds.subwatershedName,
        },
      ).then(async () => {

        // update the view model
        this.currentSite.Site_Acreage__c = siteAcreage;
        this.currentSite.Watershed_ID__c = watersheds.watershedId;
        this.currentSite.Watershed_Name__c = watersheds.watershedName;
        this.currentSite.Subwatershed_ID__c = watersheds.subwatershedId;
        this.currentSite.Subwatershed_Name__c = watersheds.subwatershedName;

        // Update the existing IndexedDB entity, if it exists
        const customStore = new Store('AcornDB', 'sites');
        get(this.currentSite.Id, customStore).then((dbSite) => {
          if (dbSite && dbSite !== null && dbSite.Id && dbSite.Id === this.currentSite.Id) {
            set(this.currentSite.Id, this.currentSite, customStore);
          }
        });

        const selectedTaxlotGlobalIds = this.selectedTaxlots.map(
          (selectedTaxlot) => selectedTaxlot.graphic.attributes.GlobalID,
        );
        const deletedSiteTaxlots = this.siteTaxlots.filter(
          (siteTaxlot) => !(selectedTaxlotGlobalIds.includes(siteTaxlot.taxlotGlobalId)),
        );
        const deleteSiteTaxlotIds = deletedSiteTaxlots.map((siteTaxlot) => siteTaxlot.recordId);
        const siteTaxlotGlobalIds = this.siteTaxlots.map((siteTaxlot) => siteTaxlot.taxlotGlobalId);
        const addedSiteTaxlots = this.selectedTaxlots.filter(
          (selectedTaxlot) => !(siteTaxlotGlobalIds.includes(
            selectedTaxlot.graphic.attributes.GlobalID,
          )),
        ).map((addedSiteTaxlot) => addedSiteTaxlot.graphic);

        const taxlotIdsExpected = this.selectedTaxlots.map((taxlot) => taxlot.graphic.attributes.GlobalID).sort();

        await this.$store.dispatch('SiteTaxlots/deleteSiteTaxlots', deleteSiteTaxlotIds).then(async () => {
          await this.$store.dispatch('SiteTaxlots/writeSiteTaxlots', { siteId: this.currentSite.Id, siteTaxlots: addedSiteTaxlots }).then(async () => {

            let taxlotsDifference = this.getSiteTaxlotsDifference(taxlotIdsExpected);
            let retry = 0;

            while ((taxlotsDifference.length !== 0) && (retry < this.config.insightly.retryLimit)) {
              await this.$store.dispatch('SiteTaxlots/readSiteTaxlots', this.currentSite.Id);
              taxlotsDifference = this.getSiteTaxlotsDifference(taxlotIdsExpected);
              retry++;
            }

            if (retry >= this.config.insightly.retryLimit) {
              this.showGetSiteTaxlotsWarning();
            }

            this.unhighlightTaxlots();
            this.btnEditShow = true;

            if (this.siteTaxlots && this.siteTaxlots.length > 0) {
              this.setViewExtentBySiteGeometry();
            } else {
              this.setViewExtentBySiteAddress();
            }
          });
        });
      });
    },
    async saveSiteGeometry(site, taxlots) {
      await loadModules([
        'esri/geometry/geometryEngine',
      ]).then(async ([geometryEngine]) => {

        let siteGeometry = geometryEngine.union(
          taxlots.map((taxlot) => taxlot.graphic.geometry),
        );

        if (!siteGeometry) {
          // Delete the feature
          await this.saveSiteGeometryDelete(site);
        } else {
          // Upsert the feature
          siteGeometry = geometryEngine.generalize(siteGeometry, 1, true, 'feet');
          await this.saveSiteGeometryUpsert(site, siteGeometry);
        }

      });
    },
    async saveSiteGeometryDelete(site) {

      const query = this.siteLayer.createQuery();
      query.where = `insightlyid = ${site.Id}`;

      await this.siteLayer.queryFeatures(query).then(async (results) => {

        if (results.features.length > 0) {
          await this.siteLayer.applyEdits({
            deleteFeatures: results.features,
          }).catch((applyEditsException) => {
            console.error('Exception raised in saveSiteGeometryDelete applyEdits()');
            console.error('applyEditsException: ', applyEditsException);
          });
        }

      }).catch((queryFeaturesException) => {
        console.error('Exception raised in saveSiteGeometryDelete queryFeatures()');
        console.error('queryFeaturesException: ', queryFeaturesException);
      });
    },
    async saveSiteGeometryUpsert(site, siteGeometry) {
      await loadModules([
        'esri/Graphic',
      ]).then(async ([Graphic]) => {

        await this.view.whenLayerView(this.siteLayer).then(async () => {

          const query = this.siteLayer.createQuery();
          query.where = `insightlyid = '${site.Id}'`;

          await this.siteLayer.queryFeatures(query).then(async (results) => {

            const applyEditsParameter = {};

            if (results.features.length === 0) {
              applyEditsParameter.addFeatures = [
                new Graphic({
                  geometry: siteGeometry,
                  attributes: {
                    insightlyid: site.Id,
                    sitename: site.RecordName,
                  },
                }),
              ];
            } else {
              applyEditsParameter.updateFeatures = results.features.map(
                (feature) => new Graphic(
                  { geometry: siteGeometry, attributes: feature.attributes },
                ),
              );
            }

            await this.siteLayer.applyEdits(applyEditsParameter).catch((applyEditsException) => {
              console.error('Exception raised in saveSiteGeometryUpsert calling applyEdits()');
              console.error('applyEditsParameter: ', applyEditsParameter);
              console.error('applyEditsException:', applyEditsException);
            });

          }).catch((queryFeaturesException) => {
            console.error('Exception raised in saveSiteGeometryUpsert queryFeatures()');
            console.error('queryFeaturesException: ', queryFeaturesException);
          });
        });
      });
    },
  },
};
</script>
